// skipcq: JS-W1028, JS-0128
import React from 'react';
import PropTypes from 'prop-types';
import { Container } from '@mui/material';
import EventDetailShellColumn from './EventDetailShellColumn';

/**
 * Event detail chrome: constrained width container wrapping the main column.
 * Kept deliberately shallow so lint rules stay satisfied.
 */
function EventDetailPageShell(props) {
  return (
    <Container maxWidth={false} sx={{ width: '100%', p: 2 }}>
      <EventDetailShellColumn {...props} />
    </Container>
  );
}

EventDetailPageShell.propTypes = {
  activeDetailTab: PropTypes.number.isRequired,
  centerBlock: PropTypes.node,
  editDisabled: PropTypes.bool.isRequired,
  featuredBeerIds: PropTypes.arrayOf(PropTypes.string),
  handleAfterFeaturedBeersRemoved: PropTypes.func.isRequired,
  handleDetailTabChange: PropTypes.func.isRequired,
  handleOpenEdit: PropTypes.func.isRequired,
  heroUrl: PropTypes.string,
  loadError: PropTypes.string,
  loadingDoc: PropTypes.bool.isRequired,
  mergedEvent: PropTypes.object,
  removeFeaturedBeersFromEvent: PropTypes.func.isRequired,
  goBackToEvents: PropTypes.func.isRequired,
};

export default EventDetailPageShell;
